<template>
  <div>
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="filter != 'all'"
            :color="filter == 'all' ? 'primary' : 'grey'"
            @click="
              filter = 'all'
              getSummary()
            "
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="filter != 'facebook'"
            :color="filter == 'facebook' ? 'primary' : 'grey'"
            @click="
              filter = 'facebook'
              getSummary()
            "
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'line'"
            :color="filter == 'line' ? 'primary' : 'grey'"
            @click="
              filter = 'line'
              getSummary()
            "
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <date-filter v-model="selectedDate" @onSelected="getLoadData"></date-filter>

      <h3 class="primary--text headline">แบ่งตามการลงทะเบียน</h3>
      <v-layout wrap>
        <v-flex xs12 sm4 class="pa-1">
          <stat-card v-model="registerStat[0]" :loading="loading">{{ $t('Total') }}</stat-card>
        </v-flex>
        <v-flex xs12 sm4 class="pa-1">
          <stat-card v-model="registerStat[1]" :loading="loading">{{ $t('Registered') }}</stat-card>
        </v-flex>
        <v-flex xs12 sm4 class="pa-1">
          <stat-card v-model="registerStat[2]" :loading="loading">{{
            $t('Not Register')
          }}</stat-card>
        </v-flex>
      </v-layout>
      <h3 class="primary--text headline">แบ่งตามเพศของลูกค้า</h3>
      <v-layout wrap>
        <v-flex xs12 sm4 class="pa-1">
          <stat-card v-model="genderStat[0]" :loading="loading">{{ $t('male') }}</stat-card>
        </v-flex>
        <v-flex xs12 sm4 class="pa-1">
          <stat-card v-model="genderStat[1]" :loading="loading">{{ $t('Female') }}</stat-card>
        </v-flex>
        <v-flex xs12 sm4 class="pa-1">
          <stat-card v-model="genderStat[2]" :loading="loading">{{ $t('no gender') }}</stat-card>
        </v-flex>
      </v-layout>
      <h3 class="primary--text headline">แบ่งตามช่วงอายุของลูกค้า</h3>
      <apexchart
        :key="`age_graph_${timestamp}`"
        ref="age_graph"
        type="bar"
        :options="ageChart"
        :series="ageStat"
      ></apexchart>
      <h3 class="primary--text headline">แบ่งตามจังหวัด</h3>
      <apexchart
        :key="`province_graph_${timestamp}`"
        ref="province_graph"
        type="bar"
        :options="provinceChart"
        :series="provinceStat"
      ></apexchart>
    </v-container>
  </div>
</template>

<script>
import DateFilter from './DateFilter'
import { mapGetters } from 'vuex'
import api from '@/api'
import StatCard from './StatCard'
import VueApexCharts from 'vue-apexcharts'

import moment from 'moment'
export default {
  data() {
    return {
      filter: 'all',
      selectedDate: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      },
      loading: true,
      genderStat: [0, 0, 0],
      registerStat: [0, 0, 0],
      ageStat: [],
      ageChart: {
        chart: {
          type: 'bar'
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {},
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        legend: {
          show: true,
          position: 'bottom'
        }
      },
      provinceStat: [],
      provinceChart: {
        chart: {
          type: 'bar'
        },
        labels: [],
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {},
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        legend: {
          show: true,
          position: 'bottom'
        },
        xaxis: {
          categories: []
        }
      },
      timestamp: moment().format('x')
    }
  },
  components: {
    DateFilter,
    StatCard,
    apexchart: VueApexCharts
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted() {
    this.getLoadData()
  },
  methods: {
    async getLoadData() {
      this.loading = true
      let promiseApi = []
      promiseApi[0] = this.getSummary()
      promiseApi[1] = this.getSahapanCountUsersByAge()
      promiseApi[2] = this.getSahapanCountUsersByProvince()

      let response = await Promise.all(promiseApi)
      this.loading = false
      this.genderStat = response[0]
      this.registerStat[0] = this.genderStat[0] + this.genderStat[1] + this.genderStat[2]
      this.registerStat[1] = this.genderStat[0] + this.genderStat[1]
      this.registerStat[2] = this.genderStat[2]
      var ageStat = []
      var ageLabels = ['N/A', '<=17', '18-24', '25-34', '35-44', '45-54', '>=55']
      response[1].length > 0
      for (const key in response[1]) {
        if (response[1].hasOwnProperty(key)) {
          let val = 0
          try {
            val = parseInt(response[1][key])
          } catch (error) {}
          ageStat.push(val)
        }
      }

      var provinceStat = []
      var provinceLabels = []
      for (const key in response[2]) {
        if (response[2].hasOwnProperty(key)) {
          let val = 0
          try {
            val = parseInt(response[2][key])
          } catch (error) {}
          provinceStat.push(val)
          provinceLabels.push(key)
        }
      }

      this.ageStat = [
        {
          data: ageStat
        }
      ]
      this.provinceStat = [
        {
          data: provinceStat
        }
      ]
      this.$set(this.ageChart, 'labels', ageLabels)
      this.$set(this.provinceChart.xaxis, 'categories', provinceLabels)
      this.timestamp = moment().format('x')
    },
    getSummary() {
      return new Promise((resolve, reject) => {
        let vm = this
        let data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'),
          app: this.filter
        }

        api.getDashboardSummary(data, function (error, response) {
          if (error) {
            console.error(error)
            reject()
          }
          if (response.data) {
            let totaluserSeries = []
            if (response.data.length > 0) {
              totaluserSeries = [
                parseInt(response.data[0].totalusers_male),
                parseInt(response.data[0].totalusers_female),
                parseInt(response.data[0].totalusers_other)
              ]
            } else {
              totaluserSeries = [0, 0, 0]
            }
            resolve(totaluserSeries)
          } else {
            reject()
          }
        })
      })
    },
    getSahapanCountUsersByAge() {
      return new Promise((resolve, reject) => {
        var data = {
          pageid: this.selectedBot.pageid
        }

        api.getSahapanCountUsersByAge(data, (error, response) => {
          if (error) {
            reject(error)
          }

          if (response.responsecode == 200) {
            resolve(response.data)
          } else {
            reject()
          }
        })
      })
    },
    getSahapanCountUsersByProvince() {
      return new Promise((resolve, reject) => {
        var data = {
          pageid: this.selectedBot.pageid
        }

        api.getSahapanCountUsersByProvince(data, (error, response) => {
          if (error) {
            reject(error)
          }

          if (response.responsecode == 200) {
            var province = []
            if (response.data) {
              response.data.map((el) => {
                if (el.province == '' || el.province == null) {
                  province['ไม่ระบุ'] = province.hasOwnProperty('ไม่ระบุ')
                    ? province['ไม่ระบุ'] + parseInt(el.count)
                    : parseInt(el.count)
                } else {
                  province[el.province] = parseInt(el.count)
                }
              })
            }
            resolve(province)
          } else {
            reject()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/StatCustomer.vue